import { DrawableObject } from '@hec/models';

export const GetTotalDrawableObjectSurface = (drawableObject: DrawableObject): number => {
  return drawableObject.height * drawableObject.width;
};
